import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    clear() {
        this.element.reset();

        const url = new URL(window.location);
        url.search = "";
        history.replaceState({}, '', url);
    }
}